import { InventoryService } from '@/services/nextshop/inventory.service.js'
import { getItemCompoud } from '../../api/inventory'
import { getLocationID, getMerchanIDCurrent, getRuleUser } from '../../utils/auth'
export async function getProductsByInventoryId(inventoryId, searchText) {
  let query = ''
  if (searchText) {
    let search = searchText.trim()
    query = `{inventoryId} == '''${inventoryId}''' and ({sku} == '''${search}''' or {meta.name} == '''${search}''')`
  } else {
    query = `{inventoryId} == '''${inventoryId}'''`
  }
  const req = {
    limit: 99,
    skip: 0,
    sort: 'ALPHABETIC_ASC',
    queryString: query,
    sortByAlphabeticField: 'meta.name'
  }
  return await InventoryService.inventoryItemList(req).then(res => {
    const response = res.data.map(r => {
      return {
        ...r,
        value: r.id,
        sku: r.itemInstance.moreInformation?.sku,
        itemInstanceName: r.itemInstance.name ? r.itemInstance.name : '',
        quantitySwitch: r.meta?.useImeiAndSerial === 'true' ? '0' : '1',
        useImeiAndSerial: r.meta?.useImeiAndSerial === 'true',
        _showDetails: r.meta?.useImeiAndSerial === 'true',
        validQuantity: null
      }
    })
    return {...res, data: response}
  })
}
export async function getInstancesByInventoryId(inventoryId) {
  let result = []
  const req = {
    queryString: `{variations.stockQuantities.inventoryDatas.inventoryId} == '''${inventoryId.trim()}'''`,
    pagingAndSorting: {
      limit: 100,
      lastIndex: '',
      sortOrder: 'DESC'
    }
  }
  getItemCompoud(req).then(res => {
    if (res.status === 'SUCCESS') {
      res.data.map(item => {
        item.variations.map(variation => {
          const priceImport = variation.prices.find(p => p.priceTypeCode === 'PRICE_IMPORT')
          const quantity = variation.stockQuantities.find(stock => stock.type === 'NSH_ITEM_SALE')
          const itemInstance = {
            ...variation,
            lineItemId: item.itemId,
            itemVariationId: variation.variationId,
            amount: 0,
            totalAmount: 0,
            itemInstanceName: variation.name,
            value: variation.variationId,
            itemInstance: {...variation, itemVariationId: variation.variationId, itemId: item.itemId, moreInformation: variation, unit: item.unit},
            quantity: quantity?.quantity,
            quantitySwitch: 1,
            unit: item.unit.name,
            unitPrice: priceImport ? (priceImport.amount/1000) : 0,
            sku: variation.sku,
            useImeiAndSerial: item.metaSearchable?.useImeiAndSerial === 'true',
            _showDetails: item.metaSearchable?.useImeiAndSerial === 'true',
            btnLoading: false,
            validQuantity: null
          }
          result.push(itemInstance)
        })
      })
      if (res.data.length > 99) {
        getInstancesByInventoryId({
          ...result,
          pagingAndSorting: {
            ...result.pagingAndSorting,
            lastIndex: res.data[99].itemId,
          },
        });
      }
    }
  })
  return result
}
export async function getInventorysByLocation(merchantId, locationId) {
  const req = {
    coLocationoId: locationId ? locationId : getLocationID(),
    coMerchantId: merchantId ? merchantId : getMerchanIDCurrent(),
    limit: 50,
    page: 1,
    textSearch: ''
  }
  return await InventoryService.inventorylist(req).then(res => {
    const responseData = res.data.filter(r => {
      return (r.isDefault && r.coLocationId === (locationId ? locationId : getLocationID()))
    }).map(inven => {
      return {
        ...inven,
        value: inven.coInventoryId
      }
    })
    return {...res, data: responseData}
  })
}